import addToCart from '../lib/addToCart';
import renderMinicart from '../lib/renderMinicart';
import { SELECTORS } from '../utils/constants';
import updateCart from '../lib/updateCart';

const RECHARGE_SELLING_PLAN_INPUT_SELECTOR = '[data-recharge-selling-plan-input]';

const initAtcForm = () => {
  if (document.body.dataset.atcFormsBound === 'true') return;
  document.body.dataset.atcFormsBound = 'true';

  const setBtnLoadingState = (button, spinner, loading) => {
    if (!button) return;

    button.classList.toggle('pointer-events-none', loading);
    button.classList.toggle('opacity-50', loading);
    if (loading) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  const getItem = (form) => {
    const variantId = +form.elements['id'].value;
    const quantity = +form.elements['quantity'].value;

    const sellingPlanEl = form.querySelector(RECHARGE_SELLING_PLAN_INPUT_SELECTOR) || form.elements['selling_plan'];
    const sellingPlan = sellingPlanEl && sellingPlanEl.value !== '' ? +sellingPlanEl.value : null;

    return [variantId, quantity, sellingPlan];
  };

  const getAttributes = (form) => {
    const attributeInputs = form.querySelectorAll('input[name^="attributes["]');
    const attributes = {};

    attributeInputs.forEach((input) => {
      const match = input.name.match(/^attributes\[(.+)\]$/);
      if (match) {
        const key = match[1];
        attributes[key] = input.value;
      }
    });
    return attributes;
  };

  const getProperties = (form) => {
    const propertyInputs = form.querySelectorAll('[name^="properties["]:not(:disabled)');
    const properties = {};

    propertyInputs.forEach((input) => {
      const match = input.name.match(/^properties\[(.+)\]$/);
      if (match) {
        properties[match[1]] = input.value;
      }
    });
    return properties;
  };

  const addVariantToCart = async (evt, form) => {
    evt.preventDefault();

    if (window.theme?.mobileVariantPicker?.openFromForm?.(form)) return;

    const submitButton = evt.submitter || form.querySelector('button[type="submit"]');
    if (!submitButton || submitButton.disabled) return;

    const submitBtnSpinner = submitButton.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(submitButton, submitBtnSpinner, true);
    try {
      const [variantId, quantity, sellingPlan] = getItem(form);
      const attributes = getAttributes(form);
      const properties = getProperties(form);

      await addToCart(variantId, quantity, sellingPlan, properties);
      if (Object.keys(attributes).length) {
        await updateCart(attributes);
      }
      await renderMinicart();
      window.theme.minicart?.open({ announcement: window.theme.strings.addedToCart });
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(submitButton, submitBtnSpinner, false);
    }
  };

  document.addEventListener('submit', (evt) => {
    const form = evt.target.closest('[data-product-form]');
    if (!form) return;

    addVariantToCart(evt, form);
  });
};

export default initAtcForm;
